import { CopilotDocTypeEnum } from "~/utils/enums/copilot/chat.enums";

/**
 * The assistant cannot read the PDF when it picks a tool (the file only reaches the tools), so the
 * intent has to travel as text: a bare file name makes it guess — and guess "session document".
 */
const DOC_TYPE_PROMPTS: Record<CopilotDocTypeEnum, (fileName: string) => string> = {
  [CopilotDocTypeEnum.TRAINING_PROGRAM]: (fileName) => `Importe ce programme de formation : ${fileName}`,
  [CopilotDocTypeEnum.ATTENDANCE_SHEET]: (fileName) => `Analyse cette feuille d'émargement : ${fileName}`,
};

/** The shortcut's prompt, written in the composer as soon as the file is staged. Empty for a raw drop. */
export function copilotDocTypePromptOf(fileName: string, docType?: CopilotDocTypeEnum): string {
  return docType ? DOC_TYPE_PROMPTS[docType](fileName) : "";
}

/**
 * The text sent alongside a staged file. What the admin typed wins when they typed something —
 * otherwise the shortcut's prompt stands in, and a bare file name is all a raw drop can offer.
 */
export function copilotSendTextOf(typed: string, fileName: string, docType?: CopilotDocTypeEnum): string {
  return typed || copilotDocTypePromptOf(fileName, docType) || fileName;
}

/**
 * Whether the composer's send button is live. An attachment alone is a message — the caller turns
 * it into the prompt it needs (`copilotSendTextOf`) — so a staged file with no typed text sends.
 */
export function copilotCanSend(
  typed: string,
  attachmentName: string | null,
  state: { disabled?: boolean; busy?: boolean } = {},
): boolean {
  if (state.disabled || state.busy) return false;

  return typed.trim().length > 0 || !!attachmentName;
}
